import { useITExplanationModal, ITExplanationModalStep } from './hooks';
import './style.scss';
import { Confirmation } from './Confirmation';
import { ElectronicDeliveryOfDisclosureDocument } from './ElectronicDeliveryOfDisclosureDocument';
import { ItDisClosureViaWebConference } from './ItDisClosureViaWebConference';
import { ItDisclosureApplicationDateSelection } from './ItDisclosureApplicationDateSelection';
import { InputMeetingDateTimeProps } from './ItDisclosureApplicationDateSelection/hooks';
import { SymbolPageStep } from '../../hooks';
import { DomesticRealEstateSymbolDetailInfo } from 'views/utils/graphql/graphql';

type ITExplanationModalProps = {
  initialModalStep?: ITExplanationModalStep;
  amount: number;
  onClosed: (nextSymbolPageStep: SymbolPageStep, meetingDateTime?: Partial<InputMeetingDateTimeProps>) => void;
  symbolDetail: DomesticRealEstateSymbolDetailInfo;
  today: Date;
};

export const ITExplanationModal = ({ amount, onClosed, initialModalStep, symbolDetail, today }: ITExplanationModalProps) => {
  const { modalStep, setModalStep, setExtraModalStep } = useITExplanationModal(initialModalStep);

  switch (modalStep) {
    case ITExplanationModalStep.CONFIRMATION:
      return <Confirmation amount={amount} setModalStep={setModalStep} onClosed={onClosed} />;
    case ITExplanationModalStep.ELECTRONIC_DELIVERY_OF_DISCLOSURE_DOCUMENT:
      return <ElectronicDeliveryOfDisclosureDocument setModalStep={setExtraModalStep} />;
    case ITExplanationModalStep.IT_DISCLOSURE_VIA_WEB_CONFERENCE:
      return <ItDisClosureViaWebConference setModalStep={setExtraModalStep} />;
    case ITExplanationModalStep.IT_DISCLOSURE_APPLICATION_DATE_SELECTION:
      return <ItDisclosureApplicationDateSelection onClosed={onClosed} symbolDetail={symbolDetail} today={today} />;
  }
};
